import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-svg-send",
  "use": "tc-svg-send-usage",
  "viewBox": "0 0 67 68",
  "content": "<symbol viewBox=\"0 0 67 68\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-svg-send\">\n<path d=\"M65.5 1L2 27L34 33M65.5 1L41 66L34 33M65.5 1L34 33\" stroke=\"#FEFCF9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol